if (!customElements.get('klaviyo-bis')) {
class BackInStockForm extends HTMLElement {

  constructor() {
    super();
    this._boundFormSubmitHandler = this.#bisFormSubmitHandler.bind(this);
    this.variantId = this.getAttribute('variant-id');
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.success = this.querySelector('[data-form-success]');
    this.form.addEventListener('submit', this._boundFormSubmitHandler);
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this._boundFormSubmitHandler);
  }

  #bisFormSubmitHandler(event) {
    event.preventDefault();
    event.stopPropagation();
    const form = this.form;
    const emailAddress = form.elements.bisEmail.value;
    const marketingOptin = form.elements.subscribeMarketing.checked;
    const variantId = this.variantId;
    const message = this.success;
    const data = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=MAUnVF`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-04-15',
        'accept': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      if (response.status !== 202) {
        message.innerText = 'Error subscribing to back in stock notification';
      }
      message.style.display = 'block';
      form.style.display = 'none';
      form.reset();
      setTimeout(function() {
        message.style.display = 'none';
        form.style.display = 'block';
      }, 5000);
      return response.text()
    })
    .catch(err => console.error(err));
    if (marketingOptin) {
      this.#suscribeToNewsletter(emailAddress);
    }
  }

  #suscribeToNewsletter(email) {

    const data = {
      "data": {
        "type": "subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": email
              }
            }
          }
        },
        "relationships": {
          "list": {
            "data": {
              "type": "list",
              "id": "N6UXBy"
            }
          }
        }
      }
    };
    fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=MAUnVF`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-04-15',
        'accept': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .catch(err => console.error(err));
  }
}
customElements.define('klaviyo-bis', BackInStockForm);
}